"use client";
import React, { useEffect } from "react";
import { AuthProvider } from "./auth";
import localFont from "next/font/local";
import "./globals.css";
import { metadata } from "./metadata";
import { withBasePath } from "./utils/basePath";

const geistSans = localFont({
  src: "./fonts/GeistVF.woff",
  variable: "--font-geist-sans",
  weight: "100 900",
});
const geistMono = localFont({
  src: "./fonts/GeistMonoVF.woff",
  variable: "--font-geist-mono",
  weight: "100 900",
});

export default function RootLayout({ children }: { children: React.ReactNode }) {
    useEffect(() => {
      if (process.env.NODE_ENV !== "production") return;
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker
          .register(withBasePath("/sw.js"))
          .then(() => console.log("Service Worker registrado com sucesso!"))
          .catch((error) => console.error("Erro ao registrar Service Worker:", error));
      }
    }, []);
  return (
    <html lang="pt">
      <head>
      <title>{metadata.title?.toString() ?? "Vendas Mobile"}</title>
      <meta name="description" content={metadata.description?? "Generated by ASKSYSTEMS"} />

        <link rel="icon" href={withBasePath("/icon-192x192.png")} />
        <link rel="manifest" href={withBasePath("/manifest.json")} />
        <meta name="theme-color" content="#4CAF50" />
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
        <meta name="apple-mobile-web-app-title" content="Vendas Mobile" />
        <link rel="apple-touch-icon" href={withBasePath("/icon-192x192.png")} />
        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />
      </head>
      <body
        className={`${geistSans.variable} ${geistMono.variable} antialiased bg-cover bg-center min-h-screen`}
        style={{ backgroundImage: `url('${withBasePath("/background.jpg")}')` }}
      >
        <div className="flex h-screen">
          <div id="__next" className="w-full bg-[#cae090] overflow-y-auto min-h-screen">
            <AuthProvider>{children}</AuthProvider>
          </div>
        </div>
      </body>
    </html>
  );
}
